"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DettaglioCertificazioneEmailDtoToJSON = exports.DettaglioCertificazioneEmailDtoFromJSONTyped = exports.DettaglioCertificazioneEmailDtoFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function DettaglioCertificazioneEmailDtoFromJSON(json) {
    return DettaglioCertificazioneEmailDtoFromJSONTyped(json, false);
}
exports.DettaglioCertificazioneEmailDtoFromJSON = DettaglioCertificazioneEmailDtoFromJSON;
function DettaglioCertificazioneEmailDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'certificazioneemail': !runtime_1.exists(json, 'certificazioneemail') ? undefined : _1.CertificazioneEmailDtoFromJSON(json['certificazioneemail']),
        'certificazioniCellulare': !runtime_1.exists(json, 'certificazioniCellulare') ? undefined : (json['certificazioniCellulare'] === null ? null : json['certificazioniCellulare'].map(_1.CertificazioneCellulareDtoFromJSON)),
    };
}
exports.DettaglioCertificazioneEmailDtoFromJSONTyped = DettaglioCertificazioneEmailDtoFromJSONTyped;
function DettaglioCertificazioneEmailDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'certificazioneemail': _1.CertificazioneEmailDtoToJSON(value.certificazioneemail),
        'certificazioniCellulare': value.certificazioniCellulare === undefined ? undefined : (value.certificazioniCellulare === null ? null : value.certificazioniCellulare.map(_1.CertificazioneCellulareDtoToJSON)),
    };
}
exports.DettaglioCertificazioneEmailDtoToJSON = DettaglioCertificazioneEmailDtoToJSON;
